<template>
  <v-row justify="space-around" max-width="820px">
    <v-card class="reflection-card">
      <v-card-title>
        <router-link
          :id="`js-reflection-${reflection.id}`"
          :to="`/reflections/${reflection.id}`"
          >{{ reflection.title }}</router-link
        >
      </v-card-title>

      <v-card-text>
        <p class="caption">{{ FormattedPostedAt(reflection.posted_at) }}</p>
        <span class="no-word-wrap js-reflection-text">
          {{ reflection.text }}
        </span>
      </v-card-text>

      <v-card-actions v-if="isEditable">
        <router-link :to="`/reflections/${reflection.id}/edit`">
          <v-btn text>Edit</v-btn></router-link
        >
        <v-btn text primary @click="DeleteReflection(`${reflection.id}`)"
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import EventBus from "@/lib/eventBus"

export default {
  props: {
    reflection: Object,
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    FormattedPostedAt: function(date) {
      var event = new Date(date)
      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
      }
      return event.toLocaleDateString("en-US", options)
    },
    DeleteReflection: function(reflectionId) {
      if (confirm("Are you sure you want to delete this? OK to delete.")) {
        EventBus.$emit("reflection:delete", reflectionId)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.reflection-card {
  width: 100%;
  max-width: 800px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.no-word-wrap {
  white-space: pre-line;
}
</style>
